import * as React from "react";
import BoundField, {ResetValue} from "components/form/BoundField/BoundField";
import Sensitive from "components/form/Sensitive/Sensitive";
import {SensitiveValue} from "client/resources/propertyValueResource";
import FormFieldProps from "components/form/FormFieldProps";

export type BoundSensitiveValue = SensitiveValue | string;
interface BoundSensitiveProps  extends FormFieldProps<BoundSensitiveValue> {
    resetValue: ResetValue;
    showVariables?: boolean;
    projectId?: string;
    label?: string | JSX.Element;
}

interface BoundSensitiveState {
    isBound: boolean;
}

export default class BoundSensitive extends React.Component<BoundSensitiveProps, BoundSensitiveState> {
    public static defaultProps: Partial<BoundSensitiveProps> = {
        showVariables: true
    };

    constructor(props: BoundSensitiveProps) {
        super(props);

        this.state = {
            isBound: this.isBoundFieldValue(props.value)
        };
    }

    render() {
        return <BoundField resetValue={this.props.resetValue}
                           showVariables={this.props.showVariables}
                           onChange={this.onChange}
                           isBound={this.state.isBound}
                           onIsBoundChanged={isBound => this.setState({isBound})}
                           value={this.state.isBound ? this.props.value as string : null}
                           projectId={this.props.projectId}>
                <Sensitive label={this.props.label}
                           value={this.state.isBound ? null : this.props.value as SensitiveValue}
                           onChange={this.onChange} />
        </BoundField>;
    }

    private onChange = (value: BoundSensitiveValue) => {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    private isBoundFieldValue(value: BoundSensitiveValue): boolean {
        return typeof value === "string";
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/BoundSensitive/BoundSensitive.tsx